import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BootstrapRankingTabsComponent } from './bootstrap-ranking-tabs/bootstrap-ranking-tabs.component';


const routes: Routes = [{
  path: '', children: [
    {
      path: 'world-ranking', loadChildren: () => import('../world-ranking-statistics/world-ranking/world-ranking.module').then(m => m.WorldRankingModule)
    },
    {
      path: 'indoor-elite-ranking', loadChildren: () => import('../indoor-module/worldarchery_indoor-world-series-elite-ranking/indoor-world-series-elite-ranking.module').then(m => m.IndoorWorldSeriesEliteRankingModule)
    },
    {
      path: 'world-cup-ranking', loadChildren: () => import('../world-ranking-statistics/wcup-ranking/wcup-ranking.module').then(m => m.WCupRankingModule)
    },
    {
      path: 'prize-precision', loadChildren: () => import('../world-ranking-statistics/prize-for-precision/prize-for-precision.module').then(m => m.PrizeForPrecisionModule)
    },
    {
      path: "classements-coupe-du-monde",
      loadChildren: () => import('../world-ranking-statistics/wcup-ranking/wcup-ranking.module').then(m => m.WCupRankingModule)
    },
    {
      path: "classement-mondial",
      loadChildren: () => import('../world-ranking-statistics/world-ranking/world-ranking.module').then(m => m.WorldRankingModule)
    },
    {
      path: "prix-precision",
      loadChildren: () => import('../world-ranking-statistics/prize-for-precision/prize-for-precision.module').then(m => m.PrizeForPrecisionModule)
    },
    {
      path: 'continental-ranking',
      loadChildren: () => import('../continental-ranking/continental-ranking.module').then(m => m.ContinentalRankingModule)
    }
  ], component: BootstrapRankingTabsComponent
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RankingTabsRoutingModule { }
